/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_In_ProgressInputs */



/**
* | output |
* | --- |
* | "In Progress" |
*
* @param {Rounds_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_in_progress = /** @type {((inputs?: Rounds_In_ProgressInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_In_ProgressInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En cours")
	if (locale === "es") return /** @type {LocalizedString} */ ("En progreso")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Em Andamento")
	if (locale === "it") return /** @type {LocalizedString} */ ("In Corso")
	return /** @type {LocalizedString} */ ("In Progress")
});